import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SERVICE_STATUS_URL } from '../../../../util/urlConstants';
import { FormText } from '@milanote/roma';
var getErrorMessage = function getErrorMessage(primaryError) {
  if (primaryError !== null && primaryError !== void 0 && primaryError.isNetworkError) {
    return /*#__PURE__*/React.createElement("span", null, "We couldn't connect to the Milanote servers.", /*#__PURE__*/React.createElement("br", null), "Check the", ' ', /*#__PURE__*/React.createElement("a", {
      href: SERVICE_STATUS_URL,
      target: "_blank",
      rel: "noopener noreferrer"
    }, "status page"), "\xA0on our website for updates.");
  }
  if (!(primaryError !== null && primaryError !== void 0 && primaryError.message) || primaryError.status === 500) {
    return /*#__PURE__*/React.createElement("span", null, "Sorry, something went wrong. Please try again or check the", ' ', /*#__PURE__*/React.createElement("a", {
      href: SERVICE_STATUS_URL,
      target: "_blank",
      rel: "noopener noreferrer"
    }, "status page"), ' ', "if you continue to have problems.");
  }
  return primaryError.message;
};
var FormError = function FormError(_ref) {
  var error = _ref.error,
    hide = _ref.hide,
    className = _ref.className;
  if (!error || hide) return null;
  return /*#__PURE__*/React.createElement(FormText, {
    size: "md",
    color: "error",
    align: "center",
    className: className
  }, getErrorMessage(error));
};
FormError.propTypes = {
  error: PropTypes.object,
  hide: PropTypes.bool,
  className: PropTypes.string
};
export default FormError;